import config from '../config';

/* Storybook requires naming for env variables to start with STORYBOOK_
https://storybook.js.org/docs/configure/environment-variables */

const REACT_APP_ROOT_ID = process.env.STORYBOOK_ROOT || config.projectRoot;

export {
  REACT_APP_ROOT_ID,
};
